module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.50145685.ttf";